export default function infoScreen(state = {}, action) {
  const { type, value } = action;
  switch (type) {
    case 'SET_INFO': {
      return {
        ...state,
        value,
      };
    }
    default:
      return state;
  }
}
